define('tinymce-plugins/wa5_image_cropping/plugin',['tinymce/AddOnManager', "tinymce/ui/Widget", "tinymce/ui/Factory",
		"tinymce/html/Serializer", "tinymce/html/Schema",
		"tinymce/html/DomParser", 'dialogs', 'lib/jquery.jcrop'],
	function(AddOnManager, Widget, Factory, Serializer, Schema, DomParser, dialogs) {

		AddOnManager.PluginManager.add('wa5_image_cropping', function(editor) {

			var dialog;
			var element;

			function showDialog() {
				element = editor.selection.getNode();
				var id = $(element).data('definition').id;

				dialog = dialogs.create('image-cropping-dialog');
				dialogs.showModal(dialog);

				$.get('/images/' + id + '/crop_dialog', function(html) {
					dialog.find('.dialog-body').html(html);

					dialog.find('#cropbox').Jcrop({
						onSelect: update,
						onChange: update,
						boxWidth: 500,
						boxHeight: 500,
						bgColor: 'white',
						bgOpacity: .3
					},function(){
						var jcrop_api = this;
						jcrop_api.setOptions({ allowMove: true });
						dim = jcrop_api.getBounds();

						var params = parseParams($(element).attr('src'));
						if (params['w'] < 0 || params['h'] < 0) {
							jcrop_api.animateTo([0, 0, dim[0], dim[1]]);
						} else {
							jcrop_api.animateTo([parseFloat(params['x']), parseFloat(params['y']),
								parseFloat(params['x']) + parseFloat(params['w']),
								parseFloat(params['y']) + parseFloat(params['h'])]);
						}
					});


				});

				dialog.find('.crop-image-button').click(function() {
					var src = '/images/' + id + '/view?x=' + dialog.find('#x-crop-param').val() + '&y='
						+ dialog.find('#y-crop-param').val() + '&w=' + dialog.find('#w-crop-param').val() + '&h='
						+ dialog.find('#h-crop-param').val();

					// compute new size
					$("<img/>").attr("src", $(element).attr("src")).load(function() {
						var originalWidth = this.width;
						var originalHeight = this.height;

						var oldWidth = $(element).prop('width');
						var oldHeight = $(element).prop('height');

						var newWidth = oldWidth * (dialog.find('#w-crop-param').val() / originalWidth);
						var newHeight = oldHeight * (dialog.find('#h-crop-param').val() / originalHeight);

						$(element).prop('width', newWidth);
						$(element).prop('height', newHeight);

						$(element).prop('src', src);
						$(element).attr('data-mce-src', src);
						var definition = JSON.parse($(element).attr('data-definition'));

						definition.src_w = dialog.find('#w-crop-param').val();
						definition.src_h = dialog.find('#h-crop-param').val();
						definition.src_x = dialog.find('#x-crop-param').val();
						definition.src_y = dialog.find('#y-crop-param').val();
						definition.width = newWidth;
						definition.height = newHeight;

						$(element).attr('data-definition', JSON.stringify(definition));
						dialogs.close(dialog);
					});
				});

				dialog.find('.cancel-button').click(function() {
					dialogs.close(dialog);
				});
			}

			function parseParams(url) {
				var regex = /[?&]([^=#]+)=([^&#]*)/g,
					params = {},
					match;
				while(match = regex.exec(url)) {
					params[match[1]] = match[2];
				}

				return params;
			}

			function update(c) {
				// update coords
				dialog.find('#x-crop-param').val(c.x);
				dialog.find('#y-crop-param').val(c.y);
				dialog.find('#w-crop-param').val(c.w);
				dialog.find('#h-crop-param').val(c.h);

				// disable submit button if nothing is selected
				var submitButton = dialog.find('.crop-image-button');
				if (c.w == 0) {
					submitButton.prop('disabled', true);
				} else {
					submitButton.prop('disabled', false);
				}
			}

			editor.addCommand('wa5_image_cropping', showDialog);

			// Open dialog on double click
			editor.on('Init', function() {
				$(editor.contentDocument.body).on('dblclick', 'img.image', function() {
					showDialog();
				});
			});
		});
	});

